import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import AddTimeForm from 'components/admin/work-orders/details/time/AddTimeForm';
import {
  showAddModalSelector,
  timeToEditSelector,
} from 'components/admin/work-orders/details/time/store/selectors';
import {
  addTimeEntry,
  editTimeEntry,
  setShowAddTimeModal,
} from 'components/admin/work-orders/details/time/store/actions';
import { getTasks } from 'selectors/admin/work-orders/work-orders';

class AddTimeModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowAddTimeModal(false));
  };

  handleOnSubmit = (values) => {
    const edit = this.props.timeToEdit !== null;
    if (edit) {
      this.props.dispatch(editTimeEntry(this.props.timeToEdit.id, values));
    } else {
      this.props.dispatch(addTimeEntry(values.taskId, values));
    }
  };

  render() {
    const { showAddModal, tasks, timeToEdit } = this.props;
    let initialValues = null;
    if (timeToEdit !== null) {
      initialValues = {
        taskId: timeToEdit.task_id,
        name: timeToEdit.name_title,
        startDate: timeToEdit.start_date,
        timeIn: timeToEdit.time_in,
        timeOut: timeToEdit.time_out,
      };
    }
    const edit = timeToEdit !== null;
    return (
      <div>
        <FormModal
          className="add-time-modal"
          show={showAddModal}
          title={edit ? 'Edit Time' : 'Add Time'}
          onClose={this.handleClose}
        >
          <AddTimeForm
            initialValues={initialValues}
            tasks={tasks}
            onSubmit={this.handleOnSubmit}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    showAddModal: showAddModalSelector(state),
    tasks: getTasks(state),
    timeToEdit: timeToEditSelector(state),
  };
})(AddTimeModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/time/AddTimeModal.js